import { SocialPublishAtField } from '@app/modules/social-export/components/inputs/SocialPublishAtField';
import { BaseExportFormProps } from '@app/modules/social-export/hooks/social-export-form-props';
import { FormSection } from '@app/core/components/FormSection';
import { zodResolver } from '@hookform/resolvers/zod';
import { socialExport } from '@mi-front/api-clients';
import { Grid } from '@mui/material';
import { FormContainer, TextFieldElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { TwitterPublishValues, useTwitterPublishSchema } from './useTwitterPublishSchema';

type TwitterPublishFormProps = BaseExportFormProps<
  socialExport.TwitterPublishDto,
  socialExport.TwitterSettingsDto
>;

export function TwitterPublishForm({ source, onUpload, actions }: TwitterPublishFormProps) {
  const { $t } = useIntl();
  const schema = useTwitterPublishSchema();
  const initialValues: TwitterPublishValues = {
    content: source.description ?? '',
    publishAt: null,
  };

  const beforeSubmit = (data: TwitterPublishValues): socialExport.TwitterPublishDto => ({
    description: data.content,
    publishAt: data.publishAt || undefined,
  });

  return (
    <FormContainer
      values={initialValues}
      mode="onBlur"
      resolver={zodResolver(schema)}
      onSuccess={async (formData) => {
        await onUpload(beforeSubmit(formData));
      }}
    >
      <FormSection
        title={$t({
          id: 'socialExport.form.content',
          defaultMessage: 'Contenido',
        })}
      >
        <TextFieldElement
          name="content"
          label={$t({
            id: 'socialExport.form.content',
            defaultMessage: 'Contenido',
          })}
          required
          fullWidth
          multiline
          rows={3}
        />
      </FormSection>
      <FormSection
        title={$t({
          id: 'socialExport.form.scheduling',
          defaultMessage: 'Programación',
        })}
      >
        <Grid container>
          <Grid item md={12}>
            <SocialPublishAtField />
          </Grid>
        </Grid>
      </FormSection>
      {actions}
    </FormContainer>
  );
}
